module.exports = __webpack_public_path__ + "img/avatar-galeria-posnania.08386afb.png";